import { mergeStyles } from '@fluentui/react';
import * as React from 'react';
import { getCommonClassNames, getCommonStyles } from '../styles/commonStyles';
import { ISignUpBrandedHeaderStyles, getSignUpHeaderClassNames } from '../styles/signUpBrandedHeaderStyles';
import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';

type ISignUpBrandedHeaderProps = IStyledComponent<ISignUpBrandedHeaderStyles>

export const SignUpBrandedHeader: React.FC<ISignUpBrandedHeaderProps> = (props) => {
    const signUpHeaderClassNames = getSignUpHeaderClassNames(props.styles, { theme: props.theme });
    const commonClassNames = getCommonClassNames(getCommonStyles!, {});
    return (
        <div id="signUpBrandedHeader" >
            <div className={signUpHeaderClassNames.containerFluid} >
                <div className={signUpHeaderClassNames.row}>
                    <div className={mergeStyles(signUpHeaderClassNames.colLgThree, signUpHeaderClassNames.colXsZero)} />
                    <div className={mergeStyles(signUpHeaderClassNames.colLgSeven, signUpHeaderClassNames.colXsTwelve)}>
                        <div className={mergeStyles(commonClassNames.textNormal, signUpHeaderClassNames.colLgTen)} id="help-content-title">
                            <h1 className={signUpHeaderClassNames.signUpHeader} id="signUpPageHeaderText" tabIndex={-1}>{getString('search_signUpPageHeaderText')}</h1>
                            <p className={mergeStyles(commonClassNames.ellipsisText, signUpHeaderClassNames.bodyCopySmall)} id="signUpPageSubHeaderText">{getString('search_signUpPageSubHeaderText')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
